import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Button, Text } from '@hhgtech/hhg-components/mantine'
import { Box, BoxProps } from '@mantine/core'
import { useIntl } from 'react-intl'

import useStyles from './index.styles'
import { useEffect } from 'react'

type Props = {
  heading: string
  description: string
  ctaText?: string
  image?: string
  onClose?: () => void
  onInit?: () => void
} & BoxProps

export const SuccessBox = ({
  heading,
  description,
  image,
  ctaText,
  styles,
  classNames,
  className,
  onClose,
  onInit,
}: Props) => {
  const { formatMessage: f } = useIntl()
  const { classes, cx } = useStyles(undefined, {
    name: 'SuccessBox',
    styles,
    classNames,
  })

  useEffect(() => {
    onInit?.()
  }, [])

  return (
    <Box className={cx(className, classes.root)}>
      <Box className={classes.body}>
        <img
          className={classes.img}
          src={image || CommonGAssets.getAssetPath('complete.svg')}
          alt="Thank you"
          loading="lazy"
        />
        <Text size="h4" className={classes.heading}>
          {heading}
        </Text>
        <Text
          size="p2"
          className={classes.description}
          sx={{ textAlign: 'center' }}
        >
          {description}
        </Text>
      </Box>

      <Button
        variant="primary"
        className={classes.button}
        onClick={() => onClose?.()}
      >
        {ctaText || f({ id: 'subot.landingPage.booking.done' })}
      </Button>
    </Box>
  )
}
